/** Allowed page sizes for paginated list tables (clients, projects, etc.). */
export const LIST_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export const DEFAULT_LIST_PAGE_SIZE = 25;

export const CLIENTS_LIST_PAGE_SIZE_STORAGE_KEY = "pmtoolbox.clients.listPageSize";
export const PROJECTS_LIST_PAGE_SIZE_STORAGE_KEY = "pmtoolbox.projects.listPageSize";
export const WORK_ITEMS_LIST_PAGE_SIZE_STORAGE_KEY = "pmtoolbox.workItems.listPageSize";
export const USERS_LIST_PAGE_SIZE_STORAGE_KEY = "pmtoolbox.users.listPageSize";
export const TEAMS_LIST_PAGE_SIZE_STORAGE_KEY = "pmtoolbox.teams.listPageSize";
export const BACKLOG_LIST_PAGE_SIZE_STORAGE_KEY = "pmtoolbox.backlog.listPageSize";
export const TIME_ENTRY_ALL_LIST_PAGE_SIZE_STORAGE_KEY = "pmtoolbox.timeEntry.allListPageSize";
export const TIME_ENTRY_TIMESHEET_LIST_PAGE_SIZE_STORAGE_KEY =
  "pmtoolbox.timeEntry.timesheetListPageSize";
export const TIME_ENTRY_TEAM_SUMMARY_LIST_PAGE_SIZE_STORAGE_KEY =
  "pmtoolbox.timeEntry.teamSummaryListPageSize";
export const TIME_ENTRY_PROJECT_SUMMARY_LIST_PAGE_SIZE_STORAGE_KEY =
  "pmtoolbox.timeEntry.projectSummaryListPageSize";
export const TIME_ENTRY_DEVELOPER_SUMMARY_LIST_PAGE_SIZE_STORAGE_KEY =
  "pmtoolbox.timeEntry.developerSummaryListPageSize";

/** Derive total pages from API meta or current list length. */
export function resolveListTotalPages(meta, pageSize, listLength = 0) {
  const fromMeta = Number(meta?.totalPages ?? meta?.total_pages);
  if (Number.isFinite(fromMeta) && fromMeta >= 1) return Math.floor(fromMeta);

  const total = Number(meta?.total ?? meta?.totalCount ?? meta?.total_count);
  if (Number.isFinite(total) && total >= 0) {
    return Math.max(1, Math.ceil(total / pageSize));
  }

  return listLength > 0 ? 1 : 0;
}

export function isValidListPageSize(value) {
  const n = Number(value);
  return LIST_PAGE_SIZE_OPTIONS.includes(n);
}

export function readStoredListPageSize(storageKey) {
  if (typeof window === "undefined" || !storageKey) return DEFAULT_LIST_PAGE_SIZE;
  try {
    const raw = window.localStorage.getItem(storageKey);
    return isValidListPageSize(raw) ? Number(raw) : DEFAULT_LIST_PAGE_SIZE;
  } catch {
    return DEFAULT_LIST_PAGE_SIZE;
  }
}

export function writeStoredListPageSize(storageKey, pageSize) {
  if (typeof window === "undefined" || !storageKey) return;
  if (!isValidListPageSize(pageSize)) return;
  try {
    window.localStorage.setItem(storageKey, String(pageSize));
  } catch {
    /* ignore quota / private mode */
  }
}
